import * as React from 'react'
import { FunctionComponent } from 'react'
import Scrollbars, { ScrollbarProps } from 'react-custom-scrollbars'
import { is } from '../../MediaQuery'

export interface IResponsiveScrollbarsProps {
  desktop?: boolean
  tablet?: boolean
  mobile?: boolean
}

export const ResponsiveScrollbars: FunctionComponent<ScrollbarProps & IResponsiveScrollbarsProps> = ({ desktop = false, mobile = false, children, ...rest }) => {
  const isDesktop = is.desktop()

  return (isDesktop && desktop) || (!isDesktop && mobile) ? (
    <Scrollbars {...rest} hideTracksWhenNotNeeded={true}>
      {children}
    </Scrollbars>
  ) : (
    <>{children}</>
  )
}
